import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ExportConfigInfoDTO} from '../../openapi/export-openapi';


/**
 * Extended ExportConfigInfo with firmaId for entity identification
 */
export interface ExportConfigEntity extends ExportConfigInfoDTO {
  firmaId: string;
}

export interface ExportConfigEntitiesState extends EntityState<ExportConfigEntity> {
  loaded: boolean;
}

export const exportConfigEntitiesAdapter: EntityAdapter<ExportConfigEntity> = createEntityAdapter<ExportConfigEntity>({
  selectId: (entity: ExportConfigEntity) => entity.id,
});

export const exportConfigEntitiesInitialState: ExportConfigEntitiesState = exportConfigEntitiesAdapter.getInitialState({
  loaded: false,
});
